import { stayTimes } from '../pages/staySettings';
import './StayRates.css';

export default function StayRates({ property }) {
  return <div className="stay-rates">
    <dl>
      <div><dt>Weekdays</dt><dd>{property.rates.weekday == null ? 'Ask your host' : <>${property.rates.weekday}<span> / night</span></>}</dd></div>
      <div><dt>Weekend</dt><dd>{property.rates.weekend == null ? 'Ask your host' : <>${property.rates.weekend}<span> / night</span></>}</dd></div>
      <div><dt>Check-in</dt><dd>{stayTimes.checkIn}</dd></div>
      <div><dt>Check-out</dt><dd>{stayTimes.checkOut}</dd></div>
    </dl>
    <p>Weekend rates apply to Friday and Saturday nights. Times are local to the property. Taxes and other fees are confirmed by your host.</p>
  </div>;
}
